<template>
  <div :class="customClass">
    <div class="cb-cart" :class="{'cb-cart--multiple': isMultipleCart}">
        <cb-slide-n-fade :is-list="true" :timeOut="true" :reCalculateMargin = "true">
        <line-item :readonly="readonly" :singleCart='!isMultipleCart' :item='item' :singleItem='isSingleItem' :currencyCode='currency_code' v-for="item in order_cart_items" v-if="loaded(item)" v-bind:key="item.id"></line-item>
        </cb-slide-n-fade>
        <slot name="addons"></slot>
    </div>
    <div class="cb-cart cb-cart--multiple cb-cart--footer" v-if="isMultipleCart">
        <div v-if="is_discount_present" class="cb-item--extras cb-transition__fade">
        <div class="cb-item__name">{{consolidated_discount.title}}
            <div @click="removeDiscount(consolidated_discount.coupon_id)" class="cb-item__action cb-extras__action" v-cb-link="'color'" v-if="coupon_enabled && consolidated_discount.coupon_id && !readonly">{{ct('cart.remove')}}</div>
        </div>
        <div class="cb-item__deduction">{{ consolidated_discount.amount | cbCurrency(currency_code, true) }}</div>
        </div>
        <div v-if="total_credits > 0" class="cb-item--extras">
          <div class="cb-item__name">{{ct('credits_applied.label')}}</div>
          <div class="cb-item__deduction">{{ total_credits | cbCurrency(currency_code, true) }}</div>
        </div>
        <!-- Exclusive taxes -->
        <div v-if="consolidated_tax && is_tax_exclusive" class="cb-item--extras">
        <div class="cb-item__name">{{consolidated_tax.title}}</div>
        <div class="cb-item__deduction">{{ consolidated_tax.amount | cbCurrency(currency_code) }}</div>
        </div>
        <div class="cb-item__total">
        {{ (amount_due || 0) | cbCurrency(currency_code) }}
        </div>
        <!-- Inclusive taxes -->
        <div class="cb-item" v-if="consolidated_tax && is_tax_inclusive">
        <div class="cb-item__name">{{cmt('included_tax_group.txt')}} {{consolidated_tax.title}} : {{ consolidated_tax.amount | cbCurrency(currency_code) }}</div>
        </div>
    </div>
    <template v-if="coupon_enabled && !is_discount_present && !readonly" ref="parent">
        <cb-discount></cb-discount>
    </template>
    <slot></slot>
  </div>
</template>
<script type="text/javascript">
import {
  mapGetters
} from "vuex"
import LineItem from "@/components/modules/hosted-pages/LineItem"
import Discount from "@/components/modules/hosted-pages/DiscountComponent"
import TierHelper from '@/utils/lineitem-tier-helper'
import CartMixin from "@/mixins/cart-mixin"
export default {
  components: {
    'line-item': LineItem,
    'cb-discount': Discount,
  },
  props: ['customClass', 'readonly'],
  mixins: [CartMixin],
  computed: {
    ...mapGetters([
      'order_cart_items',
      'currency_code',
      'consolidated_discount',
      'consolidated_tax',
      'is_tax_inclusive',
      'is_tax_exclusive',
      'coupon_enabled',
      'amount_due',
      'is_discount_present',
      'total_credits'
    ]),
    isMultipleCart() {
      return this.order_cart_items.length > 1  || this.is_discount_present || this.consolidated_tax || this.hasTieredPricing() || (this.total_credits > 0);
    }
  },
  methods: {
    loaded(item) {
      if (item.type == "plan_setup") {
        return !!item.lineItem;
      }
      return !!item.details;
    }
  }
}
</script>


// WEBPACK FOOTER //
// CartCommon.vue?af755362